import { useState, useEffect } from 'react';

type UsePaginationProps<T> = {
  items: T[] | undefined;
  pageSize: number;
};

export const usePagination = <T>({ items, pageSize }: UsePaginationProps<T>) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsToShow, setItemsToShow] = useState<T[]>([]);

  useEffect(() => {
    if (items) {
      setItemsToShow(items.slice(0, pageSize));
    }
    setCurrentPage(1);
  }, [items]);

  const onPageChange = (page: number) => {
    setCurrentPage(page);
    setItemsToShow(items?.slice((page - 1) * pageSize, page * pageSize) || []);
  };

  return { currentPage, itemsToShow, onPageChange };
};
